import { put, takeLatest } from "redux-saga/effects";
import { postOnLoginWithFaceIdApi } from "store/api/LoginApi";
import { ON_LOGIN_WITH_FACE_ID_ACTION } from "../../actions/LoginPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postOnLoginWithFaceId(action) {
	yield put(globalAction.openLoadingPage());
	const { onSuccess, onFail } = action.params;

	const res = yield postOnLoginWithFaceIdApi();
	try {
		if (res?.code === 0) {
			onSuccess(res?.data?.secretKey);
			yield showMessage(false, res?.message);
		} else {
			onFail();
			yield showMessage(true, res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postOnLoginWithFaceIdSaga() {
	yield takeLatest(ON_LOGIN_WITH_FACE_ID_ACTION, postOnLoginWithFaceId);
}

export default postOnLoginWithFaceIdSaga;
